export const Strength = {
  value: 1,
  suit: 999
};
export const Suits = ["H", "D", "C", "S"];
export const Values = [
  "2",
  "A",
  "K",
  "Q",
  "J",
  "10",
  "9",
  "8",
  "7",
  "6",
  "5",
  "4",
  "3"
];
export const FULLHOUSE_LENGTH = 5;
